export const TYPE_INVOICE = 1
export const TYPE_CREDIT_NOTE = 2
